import { Link } from "react-router-dom";
import { ArrowRight, Headphones, Play, Clock, Calendar, ExternalLink, Mic } from "lucide-react";
import { Button } from "@/components/ui/button";

const PLATFORMS = [
  { name: "Apple Podcasts", url: "https://podcasts.apple.com/us/podcast/maquis-vivant/id1869635949", icon: "https://smartlink.ausha.co/assets/listening-platforms/applePodcasts.png" },
  { name: "Spotify", url: "https://open.spotify.com/show/52wol3hDjDzCs9KyYbX06j", icon: "https://smartlink.ausha.co/assets/listening-platforms/spotify.png" },
  { name: "Deezer", url: "https://www.deezer.com/show/1002534382", icon: "https://smartlink.ausha.co/assets/listening-platforms/deezer.png" },
  { name: "Podcast Addict", url: "https://podcastaddict.com/podcast/maquis-vivant-batir-une-entreprise-durable-responsable/6701783", icon: "https://smartlink.ausha.co/assets/listening-platforms/podcast-addict.png" },
  { name: "Overcast", url: "https://overcast.fm/itunes1869635949", icon: "https://smartlink.ausha.co/assets/listening-platforms/overcast.png" },
];

const EPISODES = [
  {
    title: "Faire confiance au terrain",
    description: "Comment garder le cap et rester solide face à l'incertitude en s'inspirant directement des mécanismes du vivant.",
    duration: "14 min",
    date: "29 sept. 2026",
    cover: "https://image.ausha.co/aYcISX22XkPYo7uLB2B7xth6v4viya6YxYcjQHhZ_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/faire-confiance-au-terrain",
    guest: null,
  },
  {
    title: "S'adapter à l'environnement",
    description: "L'apprentissage et l'adaptation sont les piliers de la survie. Comment s'exposer à la nouveauté pour filtrer le stress et canaliser sa créativité ?",
    duration: "25 min",
    date: "25 aoû. 2026",
    cover: "https://image.ausha.co/PokbJ6dQYWarJRTxYJMhGAGgaIbztByWq0kiJtoG_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/s-adapter-a-l-environnement",
    guest: "Fanny Vaccarezza — Tofazze",
  },
  {
    title: "Souscrire une assurance vie",
    description: "Comment transformer votre structure optimisée mais fragile en une entreprise vivante aussi robuste et résiliente que l'Amazonie.",
    duration: "11 min",
    date: "28 juil. 2026",
    cover: "https://image.ausha.co/UsC0qd8nog1rDBMwEOfcHWHFLHceXFn57BxhYiW9_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/souscrire-une-assurance-vie",
    guest: null,
  },
  {
    title: "Façonner par la récompense",
    description: "Les systèmes de rétroaction et de récompense sont les moteurs de la coopération. Comment utiliser la reconnaissance pour orienter la croissance ?",
    duration: "23 min",
    date: "30 juin 2026",
    cover: "https://image.ausha.co/yPHPiSLddg4uWA87CmV5aTEki4Dv0OW6zpuJPIOL_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/faconner-par-la-recompense",
    guest: "Sébastien Santucci — AmHappy Corse",
  },
  {
    title: "Agir avec bon sens",
    description: "L'art d'être exactement au bon endroit au bon moment. Passer du dogme du « toujours plus » à la recherche de l'efficience.",
    duration: "8 min",
    date: "2 juin 2026",
    cover: "https://image.ausha.co/qFrx8S53klX7QElphnrei6IDObEx3c7sqxWAlVEc_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/agir-avec-bon-sens",
    guest: null,
  },
  {
    title: "Acquérir de nouvelles ressources",
    description: "Tout être vivant est programmé pour transmettre son patrimoine. Comment transmettre ses valeurs, son histoire, son savoir-faire ?",
    duration: "14 min",
    date: "7 mai 2026",
    cover: "https://image.ausha.co/fHKZYRzxPbYZAkYPvqnfNtHPCGReN9rl8x3J5yWm_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/acquerir-de-nouvelles-ressources",
    guest: "Marina Martelli — SupDesign",
  },
  {
    title: "Perdurer dans le temps",
    description: "S'inspirer du vivant pour passer les virages stratégiques avec succès et protéger votre énergie sur le long terme.",
    duration: "10 min",
    date: "31 mars 2026",
    cover: "https://image.ausha.co/SnxpnmPs1VnhZSvUYDY0Y1HUdEuKjcZifA0cRFpT_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/perdurer-dans-le-temps",
    guest: null,
  },
  {
    title: "Grandir par et avec les autres",
    description: "Pour survivre, grandir et atteindre la maturité, chaque organisation doit échanger de la matière, de l'énergie, de l'information avec son écosystème.",
    duration: "27 min",
    date: "24 fév. 2026",
    cover: "https://image.ausha.co/AL2qW4amhqsIowwCjAsxUWp6QGvyOq0TpNHjY6E0_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/grandir-par-et-avec-les-autres",
    guest: "Nicolas Llorens — Sognu di Mare",
  },
  {
    title: "Devenir une entreprise vivante",
    description: "Transformer votre organisation en « entreprise vivante » où vos ressources humaines, financières et matérielles prospèrent ensemble.",
    duration: "12 min",
    date: "27 janv. 2026",
    cover: "https://image.ausha.co/3NuLe3h4wPtHgwesxz6r7MflRa4UuemsWKkaUwik_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/devenir-une-entreprise-vivante",
    guest: null,
  },
  {
    title: "Bande-annonce — Saison 1",
    description: "Bienvenue dans Maquis Vivant, le podcast qui accompagne les entreprises à sortir du cadre et à devenir actrices de leur transformation.",
    duration: "1 min",
    date: "22 janv. 2026",
    cover: "https://image.ausha.co/LgFMa8OYmVnFcWrLy5J9bVKdN4WvkYAjwrA8wu6G_400x400.jpeg",
    url: "https://smartlink.ausha.co/maquis-vivant/batir-une-entreprise-durable-et-responsable",
    guest: null,
  },
];

const PodcastPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="podcast-page">
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 overflow-hidden bg-[#1D3557]">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#8C9D78] rounded-full blur-[150px]" />
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#C65D47] rounded-full blur-[150px]" />
        </div>
        <div className="container-custom relative z-10">
          <div className="grid lg:grid-cols-[auto_1fr] gap-10 lg:gap-16 items-center">
            {/* Cover Art */}
            <div className="flex justify-center lg:justify-start">
              <img
                src="https://image.ausha.co/LgFMa8OYmVnFcWrLy5J9bVKdN4WvkYAjwrA8wu6G_400x400.jpeg"
                alt="Maquis Vivant — podcast MOREATI"
                className="w-48 h-48 md:w-64 md:h-64 rounded-2xl shadow-2xl object-cover"
                data-testid="podcast-cover"
              />
            </div>

            {/* Info */}
            <div className="text-center lg:text-left space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-white/90">
                <Headphones className="w-4 h-4" />
                <span className="text-sm font-medium">Podcast MOREATI</span>
              </div>
              <h1
                className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                Maquis Vivant
              </h1>
              <p className="text-lg text-white/60 max-w-2xl">
                Le podcast qui accompagne les entreprises à <strong className="text-white/90">sortir du cadre</strong>, à <strong className="text-white/90">penser long terme</strong> et à <strong className="text-white/90">devenir actrices de leur transformation</strong>, sans s'épuiser ni épuiser ce qui les entoure.
              </p>
              <p className="text-white/40 text-sm">
                Par Maud Dupupet — {EPISODES.length} épisodes — Saison 1 — Production : Sonance
              </p>

              {/* Platform Buttons */}
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start" data-testid="platform-links">
                {PLATFORMS.map((platform) => (
                  <a
                    key={platform.name}
                    href={platform.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-white/10 hover:bg-white/20 text-white text-sm font-medium transition-colors"
                    data-testid={`platform-${platform.name.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    <img src={platform.icon} alt={platform.name} className="w-5 h-5 rounded" />
                    {platform.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Episodes List */}
      <section className="py-16 md:py-24" data-testid="episodes-section">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h2
              className="text-3xl font-bold text-[#1D3557] mb-10"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              Tous les épisodes
            </h2>

            <div className="space-y-4">
              {EPISODES.map((episode, index) => (
                <a
                  key={index}
                  href={episode.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex gap-4 md:gap-6 p-4 md:p-5 rounded-2xl bg-white border border-stone-200 hover:border-[#8C9D78]/50 hover:shadow-lg transition-all"
                  data-testid={`episode-${index}`}
                >
                  {/* Episode Cover */}
                  <div className="flex-shrink-0 relative">
                    <img
                      src={episode.cover}
                      alt={episode.title}
                      className="w-16 h-16 md:w-20 md:h-20 rounded-xl object-cover"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 rounded-xl bg-black/0 group-hover:bg-black/30 flex items-center justify-center transition-all">
                      <Play className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" fill="white" />
                    </div>
                  </div>

                  {/* Episode Info */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-3">
                      <div className="min-w-0">
                        <h3 className="font-semibold text-[#1D3557] group-hover:text-[#8C9D78] transition-colors text-base md:text-lg truncate">
                          {episode.title}
                        </h3>
                        {episode.guest && (
                          <p className="text-xs text-[#C65D47] font-medium mt-0.5 flex items-center gap-1">
                            <Mic className="w-3 h-3" />
                            {episode.guest}
                          </p>
                        )}
                      </div>
                      <ExternalLink className="w-4 h-4 text-stone-300 group-hover:text-[#8C9D78] flex-shrink-0 mt-1 transition-colors" />
                    </div>
                    <p className="text-sm text-stone-500 mt-1 line-clamp-2 hidden sm:block">
                      {episode.description}
                    </p>
                    <div className="flex items-center gap-4 mt-2 text-xs text-stone-400">
                      <span className="flex items-center gap-1">
                        <Clock className="w-3.5 h-3.5" />
                        {episode.duration}
                      </span>
                      <span className="flex items-center gap-1">
                        <Calendar className="w-3.5 h-3.5" />
                        {episode.date}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* About the Podcast */}
      <section className="py-16 md:py-24 bg-[#F4F1EA]">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center space-y-8">
            <h2
              className="text-3xl font-bold text-[#1D3557]"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              À propos du podcast
            </h2>
            <div className="text-stone-600 leading-relaxed space-y-4 text-left">
              <p>
                Je suis <strong>Maud Dupupet</strong>, fondatrice de <strong>Moreati</strong>, une agence de conseil en stratégie de développement durable. Après 17 ans à accompagner des entreprises dans leur stratégie de fidélisation, j'accompagne aujourd'hui les entreprises à (re)penser leur offre, (ré)inventer leur modèle, intégrer la durabilité de manière concrète et créer un futur désirable.
              </p>
              <p>
                Ici, on parle de <strong>durabilité, de responsabilité, de transition écologique, de transformation stratégique, de proximité et d'ancrage local</strong>. On aborde les défis du XXIème siècle sans culpabiliser, avec une approche accessible, pragmatique et positive.
              </p>
              <p>
                Chaque épisode vous invite à <strong>comprendre, agir, décider en reproduisant la stratégie de la nature</strong> pour résoudre un problème, un challenge, un défi.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
              <Button
                asChild
                className="bg-[#8C9D78] hover:bg-[#7A8B69] text-white rounded-full px-8 h-12 font-semibold"
              >
                <a href="https://smartlink.ausha.co/maquis-vivant" target="_blank" rel="noopener noreferrer">
                  Écouter sur Ausha
                  <ArrowRight className="w-4 h-4 ml-2" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                className="border-2 border-[#1D3557] text-[#1D3557] hover:bg-[#1D3557] hover:text-white rounded-full px-8 h-12"
              >
                <Link to="/contact">
                  Prendre rendez-vous
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PodcastPage;
